import { useCallback, useMemo, useState } from 'react'

import { getFractionType2QuestionData, FractionModel } from './FractionTypes2.utils'

interface UseFractionType2ReturnType {
  fractions: FractionModel[]
  fractionTypeToSelect: string
  formValid: boolean
  selectedAnswer?: string
  handleCheckAnswer: () => void
  onInputChange: (val?: string) => void
  goToNextQuestion: () => void
}

interface UseProperFractionProps {
  difficultyLevel: number
  onNextQuestionClick: () => void
  onAnswerStateChange: (value: boolean | null) => void
}

function useFractionTypes2({
  difficultyLevel,
  onAnswerStateChange,
  onNextQuestionClick,
}: UseProperFractionProps): UseFractionType2ReturnType {
  const [toggle, setToggle] = useState<boolean>(false)
  // eslint-disable-next-line
  const question = useMemo(() => getFractionType2QuestionData(difficultyLevel), [difficultyLevel, toggle])
  const [selectedAnswer, setSelectedAnswer] = useState<string>()

  const handleCheckAnswer = useCallback((): void => {
    if (!selectedAnswer || !question?.typeToSelect) return
    onAnswerStateChange(selectedAnswer === question.typeToSelect)
  }, [selectedAnswer, question, onAnswerStateChange])

  const onInputChange = useCallback((val?: string) => setSelectedAnswer(val), [])

  const goToNextQuestion = useCallback(() => {
    setToggle((prevState) => !prevState)
    onInputChange()
    onNextQuestionClick()
  }, [onInputChange, onNextQuestionClick])

  return {
    fractions: question.fractions,
    fractionTypeToSelect: question.typeToSelect,
    formValid: !!selectedAnswer,
    selectedAnswer,
    handleCheckAnswer,
    onInputChange,
    goToNextQuestion,
  } as const
}

export default useFractionTypes2
